import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';
import { getId } from '../../common';
import { MediaManagerSDKBoard } from '../../media-manager-sdk';
import { mediaManagerTeammatesViewClick } from '@wix/bi-logger-media-manager-g6/v2';

export enum TrackMediaManagerTeammatesViewClickOrigin {
  SidePanel = 'side_panel',
  CreateNewBoard = 'create_new_board',
}

export const useTrackTeamAnalytics = () => {
  return useMemo(
    () => ({
      trackMediaManagerTeammatesViewClick: (board: MediaManagerSDKBoard, { clickOrigin }) =>
        bi.logger().report(
          mediaManagerTeammatesViewClick({
            clickOrigin,
            boardId: getId(board),
          }),
        ),
    }),
    [],
  );
};
